const error = {
  userLimitReached: "用户数量已达上限。",
};

export { error };
